// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2BoDi","signatureButtonsRight":"ModalSign_signatureButtonsRight__dXLiW"};